module.exports = __webpack_public_path__ + "img/LsgOhr24-31.1768706a.jpeg";